<template>
    <div>
        <b-form-group
            v-if="componentType !== 'b-button'"
            :label-cols-sm="4"
            :label="label"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="10">
                    <!-- <wrapper :componentType="componentType" :attributes="attributes" /> -->

                    <Datepicker
                        v-if="componentType == 'Datepicker'"
                        :input-class="attributes.class"
                        :monday-first="true"
                        :typeable="false"
                        v-on:input="$emit('input', $event)"
                        :name="attributes.name"
                        :value="value"
                        :disabled-dates="attributes.disabledDates"
                    />

                    <vSelect
                        v-if="componentType == 'vSelect'"
                        v-model="internalValue"
                        v-bind="attributes"
                        :dynamic-width="true"
                        :select-on-tab="true"
                    />
                  
                    <vSelectMultiSelect
                        v-if="componentType == 'vSelectMultiSelect'"
                        v-model="internalValue"
                        v-bind="attributes"
                        :dynamic-width="true"
                        :select-on-tab="true"
                    />
                    <b-form-input
                        v-if="componentType == 'b-form-input'"
                        size="sm"
                        type="text"
                        v-on:input="$emit('input', $event)"
                        :value="value"
                        :name="attributes.name"
                        @keydown.enter.native="inputEvent"
                    />

                    <b-form-checkbox
                        v-if="componentType == 'b-form-checkbox'"
                        :name="attributes.name"
                        :class="attributes.class"
                        size="sm"
                        @input="$emit('input', $event)"
                        :checked="model"
                    />
                </b-col>

                <b-input-group-append v-if="attributes.showRequiredIcon">
                    <div>
                        <font-awesome-icon icon="exclamation-circle" size="lg" />
                    </div>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>

        <b-button
            v-if="componentType == 'b-button'"
            :class="attributes.class"
            :variant="attributes.variant"
            size="sm"
            @click="$emit('click', $event)"
            :name="attributes.name"
        >
            {{ attributes.label }}
            <b-spinner v-if="attributes.loading" small></b-spinner>
        </b-button>
    </div>
</template>
<script>
import wrapper from './dynamicComponentWrapper';
import Datepicker from 'vuejs-datepicker';
import vSelect from '../../vSelect';
import vSelectMultiSelect from '../../vSelectMultiSelect';


export default {
    components: {
        wrapper,
        Datepicker,
        vSelect,
        vSelectMultiSelect
    },

    computed: {
        model() {
            return this.value;
        },
        internalValue: {
          get() {
            return this.value;
          },
          set(val) {
            this.$emit('input', val);
          }
        }
    },

    resetFilter() {},

    props: {
        componentType: { type: String, required: true },
        attributes: { type: Object },
        inputEvent: { type: Function, default: function() {} },
        value: {},
        label: { type: String }
    }
};
</script>

<style></style>
